import {
  AUTH_TOKEN_KEY,
  PAYMENTS_POST,
  PAYMENTS_XENDIT_POST,
  PAYMENTS_MIDTRANS_POST,
  PAYMENTS_DETAIL_GET,
  PAYMENTS_BANK_ACCOUNTS_GET,
  PAYMENTS_BANK_TRANSFER_POST,
  PAYMENTS_KREDIVO_POST,
  PAYMENTS_APPLY_VOUCHER_POST,
  GET_VOUCHER_CODE,
  PAYMENTS_KREDIVO_INSTALLMENTS_TYPE_POST,
  PAYMENTS_MIDTRANS_DETAIL_GET,
  PAYMENTS_MIDTRANS_TOKENS_POST,
  PAYMENTS_AKULAKU_POST,
  PAYMENTS_AKULAKU_INSTALLMENTS_TYPE_POST,
  PRODUCT_ADDON_FETCH,
  PAYMENTS_ATOME_POST
} from '../constants';
import fetch from '../utils/Api';


export const doPostPayments = payload => ({
  type: PAYMENTS_POST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post('/users/payments', payload)
    .then(response => response.data)
})

export const doPostApplyVoucher = payload => ({
  type: PAYMENTS_APPLY_VOUCHER_POST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post('/vouchers/apply', payload)
    .then(response => response.data)
})

export const doGetVoucherCode = keyword => ({
  type: GET_VOUCHER_CODE,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).get('/settings', { params: keyword })
    .then(response => response.data.data)
})

export const doPostXenditPayment = (payload) => ({
  type: PAYMENTS_XENDIT_POST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post('/users/payments/xendit', payload).then(response => response.data)
})

export const doPostMidtransPayment = (payload) => {
  return {
    type: PAYMENTS_MIDTRANS_POST,
    payload: fetch({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
    }).post('/users/payments/midtrans', payload).then(response => response.data)
  }
}

export const doPostKredivoPayment = (payload) => ({
  type: PAYMENTS_KREDIVO_POST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post('/users/payments/kredivo', payload).then(response => response.data)
})

export const doPostKredivoAvailableInstallments = (product, amount) => {
  const { user_sell_id, ...productPayload } = product;
  const payload = {
    amount,
    items: [{ ...productPayload }]
  }
  return {
    type: PAYMENTS_KREDIVO_INSTALLMENTS_TYPE_POST,
    payload: fetch().post('/kredivo/payments', payload)
      .then(response => {
        return { ...response.data, variant_id: product.id, user_sell_id }
      })
  }
}

export const doPostAkulakuPayment = (payload) => ({
  type: PAYMENTS_AKULAKU_POST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post('/users/payments/akulaku', payload).then(response => response.data)
})

export const doPostSprintasiaPayment = (payload) => ({
  type: PAYMENTS_AKULAKU_POST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post('/users/payments/sprintasia', payload).then(response => response.data)
})

export const doPostAkulakuAvailableInstallments = (product) => {
  const { user_sell_id, ...productPayload } = product;
  const payload = {
    items: [{ ...productPayload }]
  }

  return {
    type: PAYMENTS_AKULAKU_INSTALLMENTS_TYPE_POST,
    payload: fetch().post('/akulaku/payments', payload)
      .then(response => {
        return { ...response.data, variant_id: product.id, user_sell_id }
      })
  }
}

export const doPostAtomePayment = (payload) => ({
  type: PAYMENTS_ATOME_POST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post('/users/payments/atome', payload).then(response => response.data)
})

export const doGetPayment = (invoice) => ({
  type: PAYMENTS_DETAIL_GET,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).get(`/users/payments/invoice/${invoice}`).then(response => response.data)
})

export const doGetBankAccounts = () => ({
  type: PAYMENTS_BANK_ACCOUNTS_GET,
  payload: fetch().get(`/bank_accounts`).then(response => response.data)
})

export const doPostBankTransferConfirm = (payload) => ({
  type: PAYMENTS_BANK_TRANSFER_POST,
  payload: fetch().post('/users/bank-transfer/confirmation/invoice', payload).then(response => response.data)
})

export const doGetMidtransPaymentDetail = invoice => ({
  type: PAYMENTS_MIDTRANS_DETAIL_GET,
  payload: fetch().get(`/midtrans/${invoice}/status`).then(response => response.data)
})

export const doGetMidtransSavedToken = payloads => ({
  type: PAYMENTS_MIDTRANS_TOKENS_POST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post('/users/payments/midtrans/saved_token', payloads).then(response => response.data)
})

export const doFetchProductAddon = (params = {}) => ({
  type: PRODUCT_ADDON_FETCH,
  payload: fetch().get(`/product-addons`, params).then((res) => {
    return res.data
  })
})